import { useEffect, useState } from 'react'

import getFileUrl from 'core/application/commons/fileStorage/getFileUrl'

import { queryRequest } from '../../common/RequestUtils'
import notification from '../../common/components/feedback/Notification'
import useQueryParams from '../../common/hooks/useQueryParams'

export const JSON_PATH = 'json'
const JsonContent = () => {
  const queryParams = useQueryParams()

  const fileName = queryParams.get('fileName')
  const [data, setData] = useState<string[][]>(null)

  const getDocumentUrl = async (filename: string) => {
    const result = await queryRequest(() => getFileUrl(filename))
    if (!result.errors) {
      return result
    } else {
      notification.open({
        type: 'error',
        message: result.errors[0].message,
      })
      return ''
    }
  }

  useEffect(() => {
    ;(async () => {
      if (fileName) {
        const srUrl = await getDocumentUrl(fileName)
        fetch(srUrl)
          .then((response) => response.json())
          .then((data) => {
            setData(data)
          })
      }
    })()
  }, [fileName])

  return (
    <>
      {data && (
        <div className={'p-6'}>
          {data.map((innerArray, index) => (
            <div key={index} className={'p-6 m-4'}>
              {innerArray.map((item, innerIndex) => (
                <span key={innerIndex} className={'border-color-gray-5 mr-8'}>
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default JsonContent
